import Timepicker from 'components/atoms/Timepicker';
import { StyledFlexbox } from 'components/atoms/Flexbox/styled';
import moment from 'moment';

import ExceptionConfigs from 'components/molecules/settings/ExceptionConfigs';

import { StyledBodyText } from '../../styled';

const ConfigExceptions = ({ newExceptionData, selectedExceptionId, onChangeDay, selectedDayFrom, selectedDayTo, data, ...props }) => {
  let exceptionsByDate = newExceptionData;

  data?.opening_hour_exceptions?.forEach((e) => {
    if (selectedExceptionId === e.id) {
      exceptionsByDate = e;
    }
    // const selectedFormattedDay = moment(selectedDay).format('YYYY-MM-DD');
    // const currentlyFormattedDay = moment(e.date).format('YYYY-MM-DD');
    // if (moment(currentlyFormattedDay).isSame(selectedFormattedDay)) {
    //   exceptionsByDate = JSON.parse(JSON.stringify(e));
    // }
  });

  return (
    <>
      <StyledBodyText style={{ textAlign: 'left' }}>
        Inserisci eventuali variazioni rispetto ai regolari orari del tuo
        servizio. <br /> Es: aperture domenicali, chiusure per ferie, feste
        nazionali.
      </StyledBodyText>
      <StyledFlexbox
        direction='column'
        marginTop={20}
        justify='center'
        align='center'
        style={{ width: '100%' }}
      >
        <Timepicker
          showMinDate={false}
          pickerAbsolute={true}
          helperText='Data dal'
          onChange={(date) => onChangeDay(date, 'date_from', selectedExceptionId)}
          selectedDate={new Date(exceptionsByDate?.date_from) || selectedDayFrom}
        />
        <Timepicker
          showMinDate={false}
          pickerAbsolute={true}
          helperText='Data al'
          onChange={(date) => onChangeDay(date, 'date_to', selectedExceptionId)}
          selectedDate={new Date(exceptionsByDate?.date_to) || selectedDayTo}
        />
      </StyledFlexbox>
      <ExceptionConfigs
        {...props}
        data={exceptionsByDate}
        selectedDay={selectedDayFrom}
        uuid={selectedDayFrom}
      />
    </>
  );
};

export default ConfigExceptions;
